/**
 * @flow
 * @relayHash e0544a1d74c5ddb37a1d9a339b45c4b6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EmailShipmentInput = {|
  shipmentId: string
|};
export type EmailShipmentMutationVariables = {|
  input: EmailShipmentInput
|};
export type EmailShipmentMutationResponse = {|
  +emailShipment: {|
    +success: boolean
  |}
|};
export type EmailShipmentMutation = {|
  variables: EmailShipmentMutationVariables,
  response: EmailShipmentMutationResponse,
|};
*/


/*
mutation EmailShipmentMutation(
  $input: EmailShipmentInput!
) {
  emailShipment(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EmailShipmentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "emailShipment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailShipmentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EmailShipmentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "EmailShipmentMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "EmailShipmentMutation",
    "id": null,
    "text": "mutation EmailShipmentMutation(\n  $input: EmailShipmentInput!\n) {\n  emailShipment(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c715d8dbc4d69fb725a9c84bc6ab7e56';
module.exports = node;
